import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-5 text-lg sm:text-xl' : 'px-6 py-4 text-base sm:text-lg';
  return <a href="#offer" className={`group inline-flex items-center justify-center gap-2 rounded-full bg-blush-500 font-display font-bold text-white shadow-soft ring-4 ring-blush-200/60 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-blush-600 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-lilac-300 active:translate-y-0 ${sizeClasses} ${className}`} data-id="element-53" data-mp="cjr8bxn0jvr7">
      {children}
    </a>;
}